import { render } from "./PaymentLiquidations.vue?vue&type=template&id=19ec45bc"
import script from "./PaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./PaymentLiquidations.vue?vue&type=script&lang=js"

import "./PaymentLiquidations.vue?vue&type=style&index=0&id=19ec45bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__